import ActiveItemsCard from "../ActiveItemsCard";
import { useIsSupportUser } from "../hooks";

export const AutomateCloudWasteCard = ({
  cloudFlowsCount,
  totalPotentialSavings,
}: {
  cloudFlowsCount: number;
  totalPotentialSavings: number;
}) => {
  const isSupportUser = useIsSupportUser();

  return (
    <ActiveItemsCard
      title="Automate waste removal"
      value={cloudFlowsCount}
      trend={`Possible CloudFlow automation${cloudFlowsCount > 1 ? "s" : ""}`}
      dataIcon="suggestion"
      trendColor="success.main"
      cloudCostsAtRisk={totalPotentialSavings}
      buttonLink="./optimize/insights"
      riskLabel="Costs at risk per year"
      disabled={isSupportUser}
      locationState={{
        filterParam: {
          category: "additionalOptions",
          value: "With CloudFlows",
        },
      }}
      trackingEvent="Automated Cloud Waste"
      trackingDescription="Review and Take Action button for automated cloud waste"
    />
  );
};
